module.exports = __webpack_public_path__ + "static/media/csm-vial.ee6eb254.svg";